export default function PreguntaTextoV2({item, onHandleTextoAnswer}){
    return(
        <>
            <label className="colorLabel">{item.title}</label>
            <textarea
                className="borderColorLabel w-100 p-2"
                rows="5"
                onChange={e=>onHandleTextoAnswer(e.target.value, item)}
            ></textarea>
        </>
    )
}